var e = function(r) {
  try {
    return !!r();
  } catch {
    return !0;
  }
};
export {
  e as f
};
